import { WeddingCakeLayers } from "./WeddingCakeLayers.js";
import { WeddingCakeSize } from "./WeddingCakeSize.js";

export const weddingCakeLayersToSizesMap: Record<WeddingCakeLayers, WeddingCakeSize[]> = {
	[WeddingCakeLayers.OneLayer]: [WeddingCakeSize.Portions12, WeddingCakeSize.Portions18],
	[WeddingCakeLayers.TwoLayers]: [
		WeddingCakeSize.Portions25,
		WeddingCakeSize.Portions30,
		WeddingCakeSize.Portions40,
		WeddingCakeSize.Portions50Double,
	],
	[WeddingCakeLayers.ThreeLayers]: [
		WeddingCakeSize.Portions50Triple,
		WeddingCakeSize.Portions60,
		WeddingCakeSize.Portions70,
		WeddingCakeSize.Portions80,
		WeddingCakeSize.Portions90,
	],
	[WeddingCakeLayers.More]: [WeddingCakeSize.Portions90Plus],
};
